import Vue from "vue";
import axios from 'axios';

const version = 'v1';
const getAllAccountHandlersApi = `${version}/accountHandler/getAll`;
const addAccountHandlersApi = `${version}/accountHandler/add`;
const updateAccountHandlersApi = `${version}/accountHandler/update`;
const deleteAccountHandlersApi = `${version}/accountHandler/delete`;
export const state = Vue.observable({
    accountHandlers: [],
    accountHandlersCount: 0
});

export const mutations = {
    async setAccountHandler(params = {}) {
        var res = await axios.post(getAllAccountHandlersApi, params);
        state.accountHandlers = res?.data?.result?.items;
        state.accountHandlersCount = res?.data?.result?.totalCount;
    },
    async addAccountHandler(AccountHandler) {
        await axios.post(addAccountHandlersApi, AccountHandler);
        await this.setAccountHandler();
    },
    async updateAccountHandler(AccountHandler) {
        await axios.put(updateAccountHandlersApi, AccountHandler);
        await this.setAccountHandler();
    },
    async deleteAccountHandler(AccountHandlerId) {
        await axios.delete(`${deleteAccountHandlersApi}/${AccountHandlerId}`);
        await this.setAccountHandler();
    },
};